import { render, staticRenderFns } from "./RecordedItemMenu.vue?vue&type=template&id=626d8c9c"
import script from "./RecordedItemMenu.vue?vue&type=script&lang=ts"
export * from "./RecordedItemMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports